import { tv } from 'tailwind-variants';

export const tableStyles = tv({
  slots: {
    container: 'flex w-full flex-col gap-6',
    root: 'w-full table-auto',
    head: 'border-b-1 border-primary-border-alt',
    headerRow: '',
    headerCell: 'px-4 py-2 text-left',
    row: 'group',
    cell: 'h-inherit px-4',
    cellContent: 'flex',
    checkboxTd: 'text-center',
    checkboxOuterContainer:
      'inline-block h-5 w-5 items-center justify-center rounded',
    checkboxInnerContainer: 'flex h-full w-full items-center justify-center',
    noRowsTd: 'py-9 pl-4'
  },

  variants: {
    clickable: {
      true: {
        row: 'cursor-pointer'
      },
      false: {
        row: ''
      }
    },

    disabled: {
      true: {
        row: 'cursor-not-allowed'
      },
      false: {
        row: ''
      }
    },

    showHeaderBorder: {
      true: {
        headerRow: 'border-b-1 border-primary-border-alt'
      },
      false: {
        headerRow: 'border-none'
      }
    },

    hideBorder: {
      true: {
        row: 'border-none'
      },
      false: {
        row: 'border-b-1 border-primary-border-alt'
      }
    },

    isSelected: {
      true: {
        checkboxOuterContainer: 'bg-highlight border-highlight'
      },
      false: {
        checkboxOuterContainer:
          '[tr:hover_&]:border-highlight border border-white/50 bg-transparent'
      }
    }
  },

  compoundVariants: [
    {
      clickable: true,
      disabled: false,
      class: {
        row: 'text-highlight hover:bg-white/5'
      }
    }
  ]
});
